import { FlowDocument } from '../../../../../services/types/Flow';
import { serviceReducer } from '../../../../../shared/hooks/serviceReducer';
import { Action, ApiState } from '../../../../../types';

export type FlowDocumentAction =
  | Action<FlowDocument[], void>
  | { type: 'ORDER'; data: FlowDocument[] };

const reducer = (
  state: ApiState<FlowDocument[], void>,
  action: FlowDocumentAction
): ApiState<FlowDocument[], void> => {
  switch (action.type) {
    case 'ORDER': {
      return { ...state, data: action.data };
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
